module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQJJREFUOE/dlOFxwjAMhT9lgo5AN2AEdYKyQZOyACOwASwASTegE1TdgA3KCJ0AcQaHc43huDa/mp/W+ZP8lPeEwqetK3teEB5/lJ0vKt6sEcuvSXqgrY9xFjifVGyske1Ffc8EQRFmaf0MipAlQm2N7EqT9mfa+ginS2FHUAKZWCPftyAJ7AFn08NOoLXbPZPkDfrJ7FVUorBqU5kX9BjbVLpjs5XXVGwvdFv5nAoTXXt467IgbNjcuYHGC/nGoiyzALIwWmHsu0C9NP8cNJDYJ1/9ff2D/ZCDWiSD/d60iRFDjIQE+ADeizECzzhPV2Mk85ni1MAI8FgLBt8hdKVgOwAP9vq9GecepgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/modbus2.png
// module id = Xhxa
// module chunks = 5